import React from 'react';
export function AntdIcon({ children }: { children?: React.ReactNode }) {
  return (
    <span role="img" aria-label="arrow-left" className="anticon ">
      {children}
    </span>
  );
}
